import request from '../request'

export default {
  sendImageTelegram(data) {
    return request.post('image', data)
  }
}
